import AutogestionLogCrudPage from './AutogestionLogCrudPage'
export {AutogestionLogCrudPage}
export default AutogestionLogCrudPage
